import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import apiService from '../services/apiService';

// Familles de machines (fallback)
const DEFAULT_FAMILLES = [
  { code: 'B1', nom: 'Palans, Ponts roulants, Portiques' },
  { code: 'B2', nom: 'Grues à tour' },
  { code: 'B3', nom: 'Grues mobiles, grues hydrauliques auxiliaires' },
  { code: 'B4', nom: 'Ponts élévateurs de véhicules' },
  { code: 'B5', nom: 'Chariots automoteurs de manutention' },
  { code: 'B6', nom: 'PEMP - Élévateurs de personnel' },
  { code: 'B7', nom: 'Hayons, tables élévatrices' },
  { code: 'B8', nom: 'Monte-matériaux, monte-meubles' },
  { code: 'B9', nom: 'Autres appareils de levage' },
  { code: 'B10', nom: 'Appareils de levage mus à bras' },
  { code: 'B11', nom: 'Engins de chantier' },
  { code: 'C1', nom: 'Accessoires de levage' },
  { code: 'D1', nom: 'Échafaudages' }
];

const TYPES_VERIFICATION = [
  'Vérification générale périodique',
  'Vérification de mise en service',
  'Vérification de remise en service'
];

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  saveBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer'
  },
  content: {
    padding: '20px'
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#92400e',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '6px'
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box'
  },
  select: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    appearance: 'none',
    backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 24 24\' stroke=\'%236b7280\'%3E%3Cpath stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'2\' d=\'M19 9l-7 7-7-7\'/%3E%3C/svg%3E")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center',
    backgroundSize: '20px'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  infoBox: {
    background: '#fef3c7',
    border: '2px solid #f59e0b',
    borderRadius: '12px',
    padding: '12px 16px',
    marginBottom: '16px'
  },
  infoText: {
    fontSize: '13px',
    color: '#92400e',
    margin: 0
  },
  badge: {
    padding: '8px 12px',
    background: '#fef3c7',
    color: '#92400e',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    marginTop: '8px',
    display: 'inline-block'
  },
  inlineRow: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  addButton: {
    padding: '12px 14px',
    borderRadius: '10px',
    border: '2px solid #f59e0b',
    background: '#fff7ed',
    color: '#92400e',
    fontWeight: '600',
    cursor: 'pointer'
  },
  addButtonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  }
};

function Etape1InfosLevageMobile({ mission, onBack, onSave }) {
  const [data, setData] = useState({
    date_verification: mission.date_verification || new Date().toISOString().split('T')[0],
    type_verification: mission.type_verification || '',
    client_id: mission.client_id || '',
    client_nom: mission.client_nom || '',
    etablissement_id: mission.etablissement_id || '',
    etablissement: mission.etablissement || '',
    site_adresse: mission.site_adresse || '',
    inspecteur_id: mission.inspecteur_id || '',
    verificateur: mission.verificateur || '',
    famille_machine_code: '',
    famille_machine_nom: '',
    famille_machine_id: '',
    designation_id: '',
    designation_nom: '',
    machine_selectionnee_id: '',
    machine_marque: '',
    machine_type: '',
    machine_numero_serie: '',
    machine_numero_parc: '',
    accompagnant_nom: '',
    accompagnant_fonction: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [designations, setDesignations] = useState([]);
  const [designationInput, setDesignationInput] = useState('');
  const [isSavingDesignation, setIsSavingDesignation] = useState(false);
  const [designationsWarning, setDesignationsWarning] = useState('');
  const [familles, setFamilles] = useState(DEFAULT_FAMILLES);
  const [famillesWarning, setFamillesWarning] = useState('');
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const cachedFamilles = await inspectionStorage.get('familles_machines');
      if (Array.isArray(cachedFamilles) && cachedFamilles.length > 0) {
        setFamilles(cachedFamilles);
        setFamillesWarning('');
      } else {
        const apiFamilles = await apiService.getFamillesMachines();
        if (apiFamilles.success && Array.isArray(apiFamilles.familles) && apiFamilles.familles.length > 0) {
          setFamilles(apiFamilles.familles);
          await inspectionStorage.set('familles_machines', apiFamilles.familles);
          setFamillesWarning('');
        } else {
          setFamilles(DEFAULT_FAMILLES);
          setFamillesWarning("Les familles levage ne sont pas encore chargées. Liste locale utilisée.");
        }
      }

      const savedData = await inspectionStorage.getStep(mission.id, 'etape_1_infos_generales_levage');
      if (savedData) {
        setData(prev => ({ ...prev, ...savedData }));
        setDesignationInput(savedData.designation_nom || '');
        
        // Charger désignations si famille déjà sélectionnée
        const resolvedFamilleId = resolveFamilleId(savedData.famille_machine_id || savedData.famille_machine_code);
        if (resolvedFamilleId) {
          await loadDesignations(resolvedFamilleId);
        }
      }

      // 🔥 Charger machines du parc client depuis cache
      if (mission.client_id) {
        await loadMachinesParc(mission.client_id);
      }
    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadDesignations = async (familleId) => {
    try {
      if (!familleId) {
        setDesignations([]);
        setDesignationsWarning('Sélectionnez une famille pour charger les désignations.');
        return;
      }

      setDesignationsWarning('');
      const cachedDesignations = await inspectionStorage.get(`designations_famille_${familleId}`);
      if (Array.isArray(cachedDesignations) && cachedDesignations.length > 0) {
        setDesignations(cachedDesignations);
        console.log(`✅ ${cachedDesignations.length} désignations chargées depuis le cache`);
        return;
      }

      const apiResult = await apiService.getDomainesMachinesByFamille(familleId);
      if (apiResult.success && Array.isArray(apiResult.domaines)) {
        const sorted = apiResult.domaines.sort((a, b) => (a.ordre || 0) - (b.ordre || 0) || (a.nom || '').localeCompare(b.nom || ''));
        setDesignations(sorted);
        await inspectionStorage.set(`designations_famille_${familleId}`, sorted);
        if (sorted.length === 0) {
          setDesignationsWarning('Aucune désignation liée à cette famille.');
        }
        return;
      }

      console.log('⚠️ Aucune désignation trouvée pour cette famille');
      setDesignations([]);
      setDesignationsWarning('Aucune désignation liée à cette famille.');
    } catch (error) {
      console.error('❌ Erreur chargement désignations:', error);
      setDesignations([]);
      setDesignationsWarning('Erreur de chargement des désignations.');
    }
  };

  // 🔥 NOUVEAU: Charger machines du parc client
  const loadMachinesParc = async (clientId) => {
    try {
      const cachedMachines = await inspectionStorage.get(`machines_client_${clientId}`);
      
      if (cachedMachines) {
        setMachines(cachedMachines);
        console.log(`✅ ${cachedMachines.length} machines chargées depuis le cache`);
      } else {
        console.log('⚠️ Aucune machine en cache pour ce client');
        setMachines([]);
      }
    } catch (error) {
      console.error('❌ Erreur chargement machines:', error);
      setMachines([]);
    }
  };

  const handleChange = (field, value) => {
    setData(prev => ({ ...prev, [field]: value }));
  };

  const resolveFamilleId = (value) => {
    if (!value) return '';
    const famille = familles.find(f => f.id === value || f.code === value || f.code_annexe === value);
    if (famille?.id) return famille.id;
    if (typeof value === 'string' && value.includes('-') && value.length >= 32) return value;
    return '';
  };

  const normalizeDesignationValue = (value) => (value || '').trim().toLowerCase();

  const findMatchingDesignation = (value) => {
    const target = normalizeDesignationValue(value);
    if (!target) return null;
    return designations.find((d) => normalizeDesignationValue(d.nom || d.libelle || d.designation) === target) || null;
  };

  const handleDesignationInputChange = (value) => {
    setDesignationInput(value);
    setData(prev => ({
      ...prev,
      designation_nom: value,
      designation_id: findMatchingDesignation(value)?.id || ''
    }));
  };

  const buildDesignationCode = (value, prefix) => {
    const cleaned = (value || '')
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
    const raw = `${prefix || 'D'}_${cleaned || 'DESIGNATION'}`;
    return raw.slice(0, 50);
  };

  const handleCreateDesignation = async () => {
    const value = (designationInput || '').trim();
    if (!value) return;
    const familleId = resolveFamilleId(data.famille_machine_id || data.famille_machine_code);
    if (!familleId) {
      alert("⚠️ Sélectionnez d'abord une famille.");
      return;
    }

    const existing = findMatchingDesignation(value);
    if (existing) {
      setData(prev => ({
        ...prev,
        designation_id: existing.id,
        designation_nom: existing.nom || value
      }));
      setDesignationInput(existing.nom || value);
      return;
    }

    setIsSavingDesignation(true);
    try {
      const createdResult = await apiService.createDomaineMachine({
        code: buildDesignationCode(value, data.famille_machine_code),
        nom: value,
        family_id: familleId,
        actif: true
      });

      if (createdResult.success && createdResult.domaine) {
        const created = createdResult.domaine;
        setDesignations(prev => {
          const next = [...prev, created];
          return next.sort((a, b) => (a.ordre || 0) - (b.ordre || 0) || (a.nom || '').localeCompare(b.nom || ''));
        });
        setData(prev => ({
          ...prev,
          designation_id: created.id,
          designation_nom: created.nom || value
        }));
        setDesignationInput(created.nom || value);
        const next = [...designations, created];
        await inspectionStorage.set(`designations_famille_${familleId}`, next);
      } else {
        throw new Error(createdResult.error || "Création échouée");
      }
    } catch (error) {
      console.error('❌ Erreur création désignation:', error);
      alert("❌ Erreur lors de l'ajout de la désignation.");
    } finally {
      setIsSavingDesignation(false);
    }
  };

  const handleFamilleChange = async (familleValue) => {
    let famille = familles.find(f => (f.id || f.code_annexe || f.code) === familleValue || f.code === familleValue || f.code_annexe === familleValue);
    let familleId = famille?.id || '';
    let familleCode = famille?.code_annexe || famille?.code || famille?.id || familleValue || '';

    if (!familleId) {
      const apiFamilles = await apiService.getFamillesMachines();
      if (apiFamilles.success && Array.isArray(apiFamilles.familles) && apiFamilles.familles.length > 0) {
        setFamilles(apiFamilles.familles);
        await inspectionStorage.set('familles_machines', apiFamilles.familles);
        famille = apiFamilles.familles.find(f => f.code === familleValue || f.code_annexe === familleValue || f.id === familleValue);
        familleId = famille?.id || '';
        familleCode = famille?.code_annexe || famille?.code || famille?.id || familleCode;
      }
    }

    if (familleCode) {
      setData(prev => ({
        ...prev,
        famille_machine_code: familleCode,
        famille_machine_nom: famille?.nom || '',
        famille_machine_id: familleId || familleCode,
        designation_id: '',
        designation_nom: ''
      }));
      setDesignationInput('');
      setDesignations([]);
      setDesignationsWarning('');
      if (familleId) {
        await loadDesignations(familleId);
      } else {
        setDesignationsWarning('Famille locale: désignations indisponibles hors connexion.');
      }
    } else {
      setData(prev => ({
        ...prev,
        famille_machine_code: '',
        famille_machine_nom: '',
        famille_machine_id: '',
        designation_id: '',
        designation_nom: ''
      }));
      setDesignationInput('');
      setDesignations([]);
      setDesignationsWarning('');
    }
  };

  const handleMachineChange = (machineId) => {
    const machine = machines.find(m => m.id === machineId);

    if (machine) {
      setData(prev => ({
        ...prev,
        machine_selectionnee_id: machineId,
        machine_marque: machine.brand || machine.marque || '',
        machine_type: machine.type || machine.type_modele || '',
        machine_numero_serie: machine.serial || machine.numero_serie || '',
        machine_numero_parc: machine.park_number || machine.numero_parc || ''
      }));

      if (machine.family_id) {
        const famille = familles.find(f => f.code === machine.family_id || f.code_annexe === machine.family_id || f.id === machine.family_id);
        if (famille) {
          const code = famille.code_annexe || famille.code || famille.id;
          const famillePayload = {
            famille_machine_code: code || '',
            famille_machine_nom: famille.nom || '',
            famille_machine_id: famille.id || code || '',
            designation_id: '',
            designation_nom: ''
          };
          setData(prev => ({ ...prev, ...famillePayload }));
          inspectionStorage.getStep(mission.id, 'etape_2_caracteristiques_techniques_levage').then((existing) => {
            const merged = { ...(existing || {}), ...famillePayload };
            return inspectionStorage.saveStep(mission.id, 'etape_2_caracteristiques_techniques_levage', merged);
          });
        }
      }
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_1_infos_generales_levage', data);
      console.log('✅ Étape 1 levage sauvegardée');
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#fffbeb' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#f59e0b', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#92400e', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Infos générales</h1>
        <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        {/* Info mission */}
        <div style={styles.infoBox}>
          <p style={styles.infoText}>
            <strong>📋 {mission.numero_rapport}</strong><br/>
            {mission.client_nom} - {mission.etablissement}
          </p>
        </div>

        {/* Client / établissement / inspecteur */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>🏢 Informations client</h3>
          <div style={styles.formGroup}>
            <label style={styles.label}>Client</label>
            <input
              type="text"
              style={styles.input}
              value={data.client_nom || ''}
              disabled
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Établissement</label>
            <input
              type="text"
              style={styles.input}
              value={data.etablissement || ''}
              disabled
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Adresse</label>
            <input
              type="text"
              style={styles.input}
              value={data.site_adresse || ''}
              disabled
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Inspecteur</label>
            <input
              type="text"
              style={styles.input}
              value={data.verificateur || ''}
              disabled
            />
          </div>
        </div>

        {/* Informations de vérification */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>📅 Vérification</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Date de vérification *</label>
            <input
              type="date"
              style={styles.input}
              value={data.date_verification}
              onChange={(e) => handleChange('date_verification', e.target.value)}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Type de vérification *</label>
            <select
              style={styles.select}
              value={data.type_verification}
              onChange={(e) => handleChange('type_verification', e.target.value)}
            >
              <option value="">Sélectionner...</option>
              {TYPES_VERIFICATION.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
        </div>

        {/* 🔥 NOUVEAU: Sélection machine du parc */}
        {machines.length > 0 && (
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>🔧 Machine du parc</h3>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Sélectionner une machine existante (optionnel)</label>
              <select
                style={styles.select}
                value={data.machine_selectionnee_id}
                onChange={(e) => handleMachineChange(e.target.value)}
              >
                <option value="">Nouvelle machine (saisie manuelle)</option>
                {machines.map(m => (
                  <option key={m.id} value={m.id}>
                    {m.brand || m.marque} {m.type || m.type_modele} - {m.park_number || m.serial || 'Sans N°'}
                  </option>
                ))}
              </select>
            </div>

            {data.machine_selectionnee_id && (
              <div style={styles.badge}>
                ✅ Machine sélectionnée : {data.machine_marque} {data.machine_type}
              </div>
            )}
          </div>
        )}

        {/* Famille machine */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>🏗️ Appareil à vérifier</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Famille (Annexe) *</label>
            <select
              style={styles.select}
              value={data.famille_machine_code}
              onChange={(e) => handleFamilleChange(e.target.value)}
            >
              <option value="">Sélectionner une famille...</option>
              {familles.map(f => (
                <option
                  key={f.id || f.code || f.code_annexe}
                  value={f.id || f.code_annexe || f.code}
                >
                  {(f.code_annexe || f.code || f.id)} - {f.nom}
                </option>
              ))}
            </select>
          </div>

          {data.famille_machine_code && (
            <div style={{ 
              padding: '12px', 
              background: '#fef3c7', 
              borderRadius: '8px', 
              marginTop: '8px' 
            }}>
              <p style={{ margin: 0, fontSize: '14px', color: '#92400e' }}>
                <strong>Annexe {data.famille_machine_code}</strong> - {data.famille_machine_nom}
              </p>
            </div>
          )}

          <div style={{ ...styles.formGroup, marginTop: '16px' }}>
            <label style={styles.label}>Désignation précise</label>
            <div style={styles.inlineRow}>
              <div style={{ flex: 1 }}>
                <input
                  type="text"
                  style={styles.input}
                  value={designationInput}
                  onChange={(e) => handleDesignationInputChange(e.target.value)}
                  onBlur={handleCreateDesignation}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleCreateDesignation();
                    }
                  }}
                  placeholder={data.famille_machine_code ? "Saisir ou sélectionner une désignation" : "Sélectionnez d'abord une famille"}
                  disabled={!data.famille_machine_code}
                  list="designation-levage-options"
                />
                <datalist id="designation-levage-options">
                  {designations.map(d => (
                    <option key={d.id} value={d.nom} />
                  ))}
                </datalist>
              </div>
              <button
                type="button"
                style={{
                  ...styles.addButton,
                  ...( !data.famille_machine_code || isSavingDesignation || !designationInput.trim()
                    ? styles.addButtonDisabled
                    : {} )
                }}
                disabled={!data.famille_machine_code || isSavingDesignation || !designationInput.trim()}
                onClick={handleCreateDesignation}
              >
                {isSavingDesignation ? 'Ajout...' : 'Ajouter'}
              </button>
            </div>
            <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '6px' }}>
              Tapez pour rechercher ou ajouter une nouvelle désignation.
            </p>
          </div>
          {designationsWarning && (
            <div style={{ ...styles.badge, background: '#fde68a', color: '#92400e' }}>
              {designationsWarning}
            </div>
          )}
          {famillesWarning && (
            <div style={{ ...styles.badge, background: '#fde68a', color: '#92400e' }}>
              {famillesWarning}
            </div>
          )}
        </div>

        {/* Accompagnant */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>👤 Personne accompagnante</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Nom</label>
            <input
              type="text"
              style={styles.input}
              value={data.accompagnant_nom}
              onChange={(e) => handleChange('accompagnant_nom', e.target.value)}
              placeholder="Nom de l'accompagnant"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Fonction</label>
            <input
              type="text"
              style={styles.input}
              value={data.accompagnant_fonction}
              onChange={(e) => handleChange('accompagnant_fonction', e.target.value)}
              placeholder="Fonction de l'accompagnant"
            />
          </div>
        </div>
      </div>

      {/* Bouton sauvegarder */}
      <div style={styles.saveSection}>
        <button 
          style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }} 
          onClick={handleSave} 
          disabled={saving}
        >
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape1InfosLevageMobile;